import { render, staticRenderFns } from "./PreciosBrentIndex.vue?vue&type=template&id=5c6b587d"
import script from "./PreciosBrentIndex.vue?vue&type=script&lang=js"
export * from "./PreciosBrentIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports